<template>
  <div>
    <vs-row class="wf-grid">
      <vs-col>
        <vx-card class="title-card h-full" title="권한수정">
          <div class="w-1/2">

            <vs-row class="form-input pb-wide">
              <vs-col><h5>역할명*</h5></vs-col>
              <vs-col><vs-input class="w-full"></vs-input></vs-col>
            </vs-row>

            <div class="table-layout">
              <vs-row class="title">
                <vs-col class="w-1/2">메뉴</vs-col>
                <vs-col class="w-1/2">권한범위</vs-col>
              </vs-row>

              <vs-row>
                <vs-col class="w-1/2">사무소 개요 > PJT 개요 - 월별PJT 현황</vs-col>
                <vs-col class="w-1/2">
                  <vs-checkbox>열람(본인작성)</vs-checkbox>
                  <vs-checkbox>열람(모두)</vs-checkbox>
                  <vs-checkbox>생성</vs-checkbox>
                  <vs-checkbox>수정</vs-checkbox>
                  <vs-checkbox>삭제</vs-checkbox>
                </vs-col>
              </vs-row>

              <vs-row>
                <vs-col class="w-1/2">사무소 개요 - PJT 개요 - 프로젝트개요</vs-col>
                <vs-col class="w-1/2">
                  <vs-checkbox>열람(본인작성)</vs-checkbox>
                  <vs-checkbox>열람(모두)</vs-checkbox>
                  <vs-checkbox>생성</vs-checkbox>
                  <vs-checkbox>수정</vs-checkbox>
                  <vs-checkbox>삭제</vs-checkbox>
                </vs-col>
              </vs-row>

              <vs-row>
                <vs-col class="w-1/2">위험성평가 - 위험성평가</vs-col>
                <vs-col class="w-1/2">
                  <vs-checkbox>열람(본인작성)</vs-checkbox>
                  <vs-checkbox>열람(모두)</vs-checkbox>
                  <vs-checkbox>생성</vs-checkbox>
                  <vs-checkbox>수정</vs-checkbox>
                  <vs-checkbox>삭제</vs-checkbox>
                </vs-col>
              </vs-row>

              <vs-row>
                <vs-col class="w-1/2">위험성평가 - 협의체회의</vs-col>
                <vs-col class="w-1/2">
                  <vs-checkbox>열람(본인작성)</vs-checkbox>
                  <vs-checkbox>열람(모두)</vs-checkbox>
                  <vs-checkbox>생성</vs-checkbox>
                  <vs-checkbox>수정</vs-checkbox>
                  <vs-checkbox>삭제</vs-checkbox>
                </vs-col>
              </vs-row>
            </div>

          </div>
        </vx-card>
      </vs-col>
    </vs-row>

    <vs-row class="w-full mt-8" vs-justify="center">
      <vs-button class="mr-4 large" style="width:220px;" color="#EDEDED" text-color="black" type="filled" @click="handleCancel">취소</vs-button>
      <vs-button class="large" style="width:220px;" color="secondary" >저장</vs-button>
    </vs-row>
  </div>
</template>

<script>
export default {
  name: 'MemberAuthCreated',

  methods:{
    handleCancel () {
      this.$router.back()
    }
  }
}
</script>

<style >

.wf-grid { display: grid !important; grid-template-columns: 1fr; grid-gap: 32px; grid-template-rows: 100%;}

.pb-wide{ padding-bottom:1.5rem;}
.title-card .vx-card__header {
  padding:1.5rem;
  border-bottom: 1px solid #EAEAEA;
}
.cover{
  background-color: #F6FAFF;
  border: 1px solid #6670CB;
  border-radius: 8px;
}
.cover p { font-size:14px; font-weight: 500;}

.form-input h5 {font-size:14px; margin-bottom:8px;}
.table-layout { border:1px solid #CDCDCD; border-radius: 8px;}
.table-layout .vs-row { border-bottom:1px solid #CDCDCD;}
.table-layout .vs-row:last-child { border-bottom:none; }
.table-layout .vs-row .vs-col {padding:14px;}
.table-layout .vs-row .vs-col.title {padding:7px 14px;}
.table-layout .vs-row .vs-col .vs-checkbox { margin-bottom:7px; }
.table-layout .title {font-size:14px; font-weight:500 ;}


.actor-table { border:1px solid #CDCDCD; border-radius: 8px;}
.actor-table .vs-row { border-bottom:1px solid #CDCDCD;}
.actor-table .vs-row:last-child { border-bottom:none; }
.actor-table .vs-row.header .vs-col,
.actor-table .vs-row.footer .vs-col {padding:14px; text-align: center;}
.actor-table .vs-row.body .vs-col .list-item {padding:14px; align-items: center;}
.actor-table .vs-row.body .vs-col .list-item .vs-image{ width:70px; height:70px; margin-right:7px; background-color: lightgray }
.actor-table .vs-row .vs-col.title {padding:7px 14px;}
</style>
